import React from 'react';
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';

interface Props {
  showVatRegNo: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textCentre: {
      textAlign: 'center'
    }
  })
);

export const InvoiceHeader: React.FunctionComponent<Props> = (props) => {
    const classes = useStyles();

    return (
        <Box className={classes.textCentre}>
          <div>Zen Internet Ltd, Sandbrook Park, Sandbrook Way, Rochdale, OL11 1RY</div>
          <div>
            <strong>Email:</strong>&nbsp;&nbsp;
            <a href="mailto:creditandbilling@zen.co.uk" rel="noreferrer" target="_blank">creditandbilling@zen.co.uk</a> &nbsp;|&nbsp;&nbsp;
        
            <strong>Web:</strong>&nbsp;&nbsp;
            <a href="https://www.zen.co.uk" rel="noreferrer" target="_blank">https://www.zen.co.uk</a> &nbsp;|&nbsp;&nbsp;

            <span><strong>Tel:</strong>&nbsp; 01706 902003</span>&nbsp;|&nbsp;&nbsp;

            { props.showVatRegNo && <><br /><span><strong>Vat reg no.:</strong>&nbsp; 686 0495 01</span></> }
          </div>
        </Box>
    )
}